import {
  FETCH_APPRAISER_SPECIALIZATIONS_REQUEST,
  FETCH_APPRAISER_SPECIALIZATIONS_SUCCESS,
  FETCH_APPRAISER_SPECIALIZATIONS_FAILURE,
  SAVE_APPRAISER_SPECIALIZATIONS_REQUEST,
  SAVE_APPRAISER_SPECIALIZATIONS_SUCCESS,
  SAVE_APPRAISER_SPECIALIZATIONS_FAILURE,
} from '@actions/appraiserSpecializations'
import { LOADING, SUCCEEDED, ERROR, IDLE } from '@constants/fetchStatuses'

const initialState = {
  data: null,
  status: IDLE,
  errorMessage: null,
}

export default function appraiserSpecializations(state = initialState, action) {
  switch (action.type) {
    case FETCH_APPRAISER_SPECIALIZATIONS_REQUEST:
    case SAVE_APPRAISER_SPECIALIZATIONS_REQUEST:
      return { ...state, status: LOADING, errorMessage: null }
    case FETCH_APPRAISER_SPECIALIZATIONS_SUCCESS:
    case SAVE_APPRAISER_SPECIALIZATIONS_SUCCESS:
      return { data: action.data, status: SUCCEEDED, errorMessage: null }
    case FETCH_APPRAISER_SPECIALIZATIONS_FAILURE:
    case SAVE_APPRAISER_SPECIALIZATIONS_FAILURE:
      return { ...state, status: ERROR, errorMessage: action.errorMessage }
    default:
      return state
  }
}
